import { endpoints } from 'constants/endpoints'
import api from 'services/api'

import type {
  Pagination,
  PatchRangeBody,
  PostRangeBody,
  RangeReviewBody,
  RangeVersion,
  TeamRange,
  TrackingData,
} from './interfaces'

export const getTeamRangesData = async (office: string) => {
  const response = await api.get<TeamRange[]>(endpoints.backofficeRanges.list, {
    params: { escritorio: office },
  })
  return response.data
}

export const getRangeVersion = async (office: string) => {
  const response = await api.get<RangeVersion>(endpoints.backofficeRanges.version, {
    params: { escritorio: office },
  })
  return response.data
}

export const postRangeUpdate = async (payload: PostRangeBody) => {
  const response = await api.post(endpoints.backofficeRanges.update, payload)
  return response.data
}

export const patchRangeUpdate = async (payload: PatchRangeBody) => {
  const response = await api.patch(endpoints.backofficeRanges.review, payload)
  return response.data
}

export const sendRangeUpdate = async (version: number) => {
  const response = await api.post(endpoints.backofficeRanges.requestReview, {
    codigoVersao: version,
  })
  return response.data
}

export const setRangeVisualization = async (version: number) => {
  const response = await api.post(endpoints.backofficeRanges.reviewVisualization, {
    CodigoVersao: version,
  })
  return response.data
}

export const postRangeReview = async (payload: RangeReviewBody) => {
  const response = await api.post(endpoints.backofficeRanges.reviewAnalysis, payload)
  return response.data
}

export const getTrackingData = async (pagination: Pagination) => {
  const response = await api.get<TrackingData[]>(endpoints.backofficeRanges.history, {
    params: pagination,
  })
  return response.data
}

export const downloadRangeExcel = async () => {
  const response = await api.get(endpoints.backofficeRanges.downloadExcel, {
    headers: {
      'Content-Disposition': 'attachment"',
      'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    },
    responseType: 'blob',
  })
  return response.data
}
